<template>
  <div>
    <div class="flex flex-col mb-4" v-if="signDialogData.isSignatureCodeMandatory">
      <ValidationProvider :name="$t('signworkflows.sign.signatureCode')" rules="required|validation_code" v-slot="{ errors, valid, invalid }">
        <EuiTextField :warning="invalid && errors.length === 0"
                      :invalid="errors.length > 0"
                      :valid="valid">
          <EuiLabel for="signatureCode">{{ $t('signworkflows.sign.signatureCode') }}</EuiLabel>
          <EuiInput v-model="signDialogData.signatureCode"
                    :placeholder="$t('signworkflows.sign.signatureCode.placeholder')"
                    :warning="invalid && errors.length === 0"
                    :invalid="errors.length > 0"
                    :valid="valid"/>
          <template #errorMessage>
            <template v-for="(error) in errors">
              {{ error }}
            </template>
          </template>
        </EuiTextField>
      </ValidationProvider>
      <!-- retrieve signature code -->
      <button class="es-sign-dialog__link eui-u-mt-4"
              @click.prevent="signDialogData.goToStep(1)"
              v-html="$t('signworkflows.sign.signatureCode.forgotten')">
      </button>
      <EuiCheckbox v-model="signDialogData.agreement" class="mt-4">
        {{ $tc('signDialog.agreement', nbDocuments) }}
        <template v-if="signerSignWithMandat">{{ $tc('signDialog.agreementMandat', nbDocuments) }}</template>
        <template v-if="signerSignWithMandat && !signDialogData.isLastSignatory"> {{ $tc('signDialog.severalSigners', nbDocuments) }}</template>
      </EuiCheckbox>
    </div>
    <template v-if="!isMobile && signDialogData.isSignatureCodeMandatory && isUsbSignAvailable">
      <EuiDivider secondary/>
      <EuiHeading :level="4" bold class="mb-4">{{ $t('signworkflows.sign.usbKey') }}</EuiHeading>
      <!-- sign with usb key -->
      <button class="es-sign-dialog__link"
              @click.prevent="$emit('sign'); signDialogData.goToStep(3.2)"
              v-html="$t('signworkflows.sign.retrieveMode.usb')">
      </button>
      <EuiDivider secondary/>
    </template>
  </div>
</template>

<script>
import {mapGetters, mapState} from 'vuex';

export default {
  name: 'Code',
  inject: ['signDialogData'],
  props: {
    signworkflows: {
      type: Array,
      required: true,
    },
    isUsbSignAvailable: {
      type: Boolean,
    },
  },
  computed: {
    ...mapState({
      isMobile: (state) => state.application.isMobile,
    }),
    ...mapGetters({
      options: 'ModuleEdocSign/auth/options',
    }),
    signerSignWithMandat() {
      if (this.options && this.options.signerSignWithMandat) {
        return this.options.signerSignWithMandat.value === '1' || this.options.signerSignWithMandat.value === true;
      }
      return false;
    },
    nbDocuments() {
      const docsId = [];
      this.signworkflows.forEach((signworkflow) => {
        signworkflow.steps.forEach((step) => {
          step.docsToSign.forEach((doc) => {
            if (docsId.indexOf(doc) === -1) {
              docsId.push(doc);
            }
          });
        });
      });
      return docsId.length;
    },
  },
  methods: {
    setSelectedSignatureMode(value) {
      if (value) {
        if (this.signDialogData.isSignatureCodeMandatory && value.electronicSignatureImageTypeUsedByDefault) {
          this.signDialogData.selectedSignatureMode = value.electronicSignatureImageTypeUsedByDefault.value;
          return value.electronicSignatureImageTypeUsedByDefault.value;
        }
        if (value.visaSignatureImageTypeUsedByDefault) {
          this.signDialogData.selectedSignatureMode = value.visaSignatureImageTypeUsedByDefault.value;
          return value.visaSignatureImageTypeUsedByDefault.value;
        }
        this.signDialogData.selectedSignatureMode = 'auto-generated';
        return 'auto-generated';
      }
    },
  },
  created() {
    this.setSelectedSignatureMode(this.options);
    this.signDialogData.hasSignatureCode = this.signDialogData.signatureCode && this.signDialogData.signatureCode.length > 5;
    this.signDialogData.agreement = false;
    this.signDialogData.signatureStatus = '';
  },
};
</script>
